import axios from "axios";
import TokenService from "./token.service";
import { endSession } from "./session";

const baseURL = process.env.REACT_APP_API_URL;

let inflight = null;

// One refresh shared by every 401 in flight, across both axios instances.
// Refresh tokens rotate and the old one is blacklisted, so two parallel
// refreshes would have the second fail and log the user out mid-session.
export const refreshAccessToken = () => {
  if (!inflight) {
    inflight = axios
      .post(baseURL + "/auth/refresh/", {
        refresh: TokenService.getLocalRefreshToken(),
      })
      .then((rs) => {
        TokenService.updateLocalAccessToken(rs.data.access);
        // The rotated refresh token: without storing it the next refresh
        // presents a blacklisted one and the session ends a few minutes in.
        if (rs.data.refresh) {
          TokenService.updateLocalRefreshToken(rs.data.refresh);
        }
        return rs.data.access;
      })
      .catch((err) => {
        TokenService.removeTokens();
        endSession();
        throw err;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};
